import { Optional, Provider, SkipSelf } from '@angular/core';

import { PROTECTED_CONTROLS_CONTEXT, ProtectedControlsContext } from './protected-controls.context';
import { ProtectedControlsService } from './protected-controls.service';

export function protectedControlsServiceFactory(
  parent: ProtectedControlsService,
): ProtectedControlsService {
  return new ProtectedControlsService(parent);
}

export function protectedControlsServiceFactoryWithoutParent(): ProtectedControlsService {
  return new ProtectedControlsService();
}

export function protectedControlsContextFactory(
  contextName: string[],
  parent: ProtectedControlsContext,
): ProtectedControlsContext {
  return new ProtectedControlsContext(contextName, parent || null);
}

export const PROTECTED_CONTROLS_CONTEXT_PROVIDER = {
  provide: ProtectedControlsContext,
  useFactory: protectedControlsContextFactory,
  deps: [PROTECTED_CONTROLS_CONTEXT, [new SkipSelf(), new Optional(), ProtectedControlsContext]],
};

export function providersForControlsContext(useValue: string): Provider[] {
  return [
    {
      provide: PROTECTED_CONTROLS_CONTEXT,
      useValue: useValue,
      multi: true,
    },
    PROTECTED_CONTROLS_CONTEXT_PROVIDER,
  ];
}

export const PROTECTED_CONTROLS_PROVIDERS = [
  {
    provide: ProtectedControlsService,
    useFactory: protectedControlsServiceFactory,
    deps: [[new SkipSelf(), new Optional(), ProtectedControlsService]],
  },
  {
    provide: PROTECTED_CONTROLS_CONTEXT,
    useValue: 'app',
    multi: true,
  },
  PROTECTED_CONTROLS_CONTEXT_PROVIDER,
];
